/**
 * Site JS
 */

import './global';
import './template-tags';
import './templates';
import './blocks';

const sections = document.querySelectorAll(
	'.section1, .section2, .section3, .section4, .section5, .section6, .section7, .section8, .section9, .sectionTen, .sectionEleven, .sectionTwelve, .sectionThirteen, .sectionFourteen'
);

const observer = new IntersectionObserver(
	( entries ) => {
		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				entry.target.classList.add( 'is-visible' );
			} else {
				entry.target.classList.remove( 'is-visible' );
			}
		} );
	},
	{
		rootMargin: '-110px 0px',
	}
);

sections.forEach( ( section ) => {
	observer.observe( section );
} );
